import { SiteRecceStatusEnum } from '@api/enum';
import { LinearProgress } from '@hyperflake/react-ui-library';
import { BackButton } from '@library/buttons';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import OperationUpdateSiteRecceForm from 'modules/site-recce/components/OperationUpdateSiteRecceForm/OperationUpdateSiteRecceForm';
import UpdateSiteRecceForm from 'modules/site-recce/components/UpdateSiteRecceForm/UpdateSiteRecceForm';
import useSiteRecceData from 'modules/site-recce/hooks/useSiteRecceData';

import { useParams, useSearchParams } from 'react-router-dom';

const OperationUpdateSiteReccePage = () => {
    const [searchParams] = useSearchParams();
    const clientInstallationId = searchParams.get('clientInstallationId')!;
    const projectInstallationId = searchParams.get('projectInstallationId')!;
    const siteRecceId = searchParams.get('siteRecceId')!;
    const {
        siteRecce: initialData,
        isLoading,
        setData,
    } = useSiteRecceData(clientInstallationId!, projectInstallationId!, siteRecceId);
    const activeStatus = (searchParams.get('status') as SiteRecceStatusEnum) || SiteRecceStatusEnum.UNASSIGNED;
    return (
        <>
            {isLoading ? (
                <LinearProgress />
            ) : (
                <PageTemplate>
                    <PageHeading className="md:flex  items-center gap-4 ">
                        <div>
                            <BackButton to={`/all-site-recce?status=${activeStatus}`} />
                        </div>

                        <div className="mt-2 md:mt-0">Update Site Recce</div>
                    </PageHeading>
                    <OperationUpdateSiteRecceForm
                        clientInstallationId={clientInstallationId}
                        projectInstallationId={projectInstallationId}
                        initialData={initialData}
                        setData={setData}
                    />
                </PageTemplate>
            )}
        </>
    );
};

export default OperationUpdateSiteReccePage;
